// extracted by mini-css-extract-plugin
module.exports = {"nav":"styles-module--nav--16sq4","white":"styles-module--white--3xn96"};